import cookie from "js-cookie"
export default cookie